import * as Yup from 'yup';
export const ConnectValidationSchema = Yup.object().shape({
    apiKey: Yup.string().required(),
    publicationId: Yup.string()
        .required()
        .matches(/^pub_/, 'PublicationId should start with "pub_" prefix'),
});
